import { render } from "./esco-chat-de-questoes.vue?vue&type=template&id=31c612ff"
import script from "./esco-chat-de-questoes.vue?vue&type=script&lang=js"
export * from "./esco-chat-de-questoes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__